import { useState } from "react"
import BodySimpleModalV3 from "../common/modal/BodySimpleModalV3"
import Button from "../common/Button"
import { useDispatch, useSelector } from "react-redux"
import { exportHistory } from "../../lib/fetchApi";
import { notificationActions } from "../../store/notifications";

export default function ExportHistory() {
    const [loading, setLoading] = useState(false)
    const selectedFilters = useSelector(state => state.history.filters)
    const userToken = useSelector(state => state.user.token)
    const dispatch = useDispatch()
    async function exportHistoryHandler() {     
        let filterParams = null

        if (selectedFilters && Object.keys(selectedFilters).length > 0 && Object.values(selectedFilters).some(value => value !== null)) {
            
            filterParams = Object.entries(selectedFilters)
                .filter(([key, val]) => val != null && val.value !== undefined && val.value !== null && val.value !== '')
                .map(([key, val]) => {
                    if (typeof val === 'object' && val.value !== undefined) {
                        if (Array.isArray(val.value)) {
                            return `${encodeURIComponent(key)}=${encodeURIComponent(val.value.join(','))}`;
                        }
                        return `${encodeURIComponent(key)}=${encodeURIComponent(val.value)}`;
                    }
                    return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
                })
                .join('&');           
            
        }
        setLoading(true)
        let response = await exportHistory(userToken, filterParams)
        
        if (response && response.errorMessage) {
            dispatch(notificationActions.setError(response))
        } else {            
            dispatch(notificationActions.setError({errorMessage: `History data queued successfully. You can check the status of the export in the exports page.`, type: 'success'}))
        }
        setLoading(false)
    }
    return (
        <>
            <BodySimpleModalV3 message={'Export'}>
                <Button click={exportHistoryHandler} isLoading={loading}>
                        <i className="ti ti-file-arrow-right"></i>
                </Button>
            </BodySimpleModalV3>
        </>
    )
}